<template>
  <div class="parking-fee-container">
    <div class="nav-bar">
      <div class="title">扫码停车</div>
    </div>
    <div class="main" v-if="showParkingInfo && parkingInfo.licensePlateNumber">
      <div class="header">
        <van-divider :hairline="false" :style="{
          color: '#333',
          margin: 0,
          fontSize: 14,
          fontWeight: 700
        }">车牌号</van-divider>
        <div class="car-no">{{ parkingInfo.licensePlateNumber }}</div>
      </div>

      <div class="content">
        <div class="title">停车信息</div>
        <div class="list">
          <div class="item">
            <div class="leading">停车场名称</div>
            <div class="trailing">{{ parkingInfo.parkName || '-' }}</div>
          </div>
          <div class="item">
            <div class="leading">已停时间</div>
            <div class="trailing">{{ parkingInfo.parkTime || '-' }}</div>
          </div>
          <div class="item">
            <div class="leading">进场时间</div>
            <div class="trailing">{{ parkingInfo.parkStartTime || '-' }}</div>
          </div>
          <div class="item">
            <div class="leading">停车费用</div>
            <div class="trailing primary">{{ parkingInfo.payAmount }}元</div>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="pay-btn" @click="handlePay">
          立即缴费（{{ parkingInfo.payAmount }}元）
        </div>

        <div class="explain">
          <div class="title">临停支付说明</div>

          <div class="desc-list">
            <div class="p">
              1.若因特殊原因无法查询车辆及缴费信息，请至人工收费处或联系客服进行处理
              <span class="strong">客服热线: <a href="tel:0871-68888889">0871-68888889</a></span>。
            </div>
            <div class="p">2.缴费前请仔细核对车场及车牌号信息。</div>
            <div class="p">
              3.玉溪站00:00-8:00免费放行，8:00以后出场按照入场时间全程收费。
            </div>
            <div class="p">
              4.若支付超时或者支付错误，请重新扫码支付。
            </div>
            <div class="p">
              5.若无法加载页面，请检查网络是否畅通，或重新加载页面。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="other-status" v-else-if="!loading">
      <template v-if="isSuccess">
        <img class="icon" src="@/assets/images/icons/icon-success.png" alt="success" />
        <div class="status">支付成功, 感谢您的使用~</div>
        <div class="hint">为避免产生额外费用，支付成功后请立即出场</div>
      </template>
      <template v-else>
        <img class="no-data" src="@/assets/images/icons/no-data.png" alt="no-data" />
        <div class="no-vehicle">暂未查询到车辆信息</div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  getParkingInfo,
  parkingPay
} from '@/api/modules/parking'
import { YB_PAY_TYPES } from '@/utils/constant'
import { getLoginCode } from '@/utils/authorize'
export default {
  created() {
    this.getParkingInfo(this.$route.query);
    getLoginCode();
  },
  data() {
    return {
      isSuccess: false,
      parkingInfo: {},
      loading: false
    }
  },
  computed: {
    isAli() {
      return /AlipayClient/.test(window.navigator.userAgent)
    },
    showParkingInfo() {
      if (!this.isSuccess && !this.loading) {
        return true
      }
      return false
    }
  },
  methods: {
    /**
     * 获取停车信息
     */
    async getParkingInfo(params) {
      try {
        this.loading = true
        const res = await getParkingInfo(params)
        this.parkingInfo = this._formatData(res)
        // 查询是否缴费成功
        // const statusRes = await getOrderStatus({
        //   orderId: res.id,
        //   tradeType: 0
        // })
        // if (statusRes.orderStatus === 1) {
        //   this.isSuccess = true
        // }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    /**
     * 格式化数据
     * @param {*} data
     */
    _formatData(data) {
      data.licensePlateNumber =
        data.licensePlateNumber.substr(0, 2) +
        '·' +
        data.licensePlateNumber.substr(2)
      if (data.parkTime) {
        const h = moment.duration(data.parkTime, 'hour')
        let str = ''
        if (h.days() > 0 && h.hours() > 0) {
          str += `${h.days()}天`
        } else if (h.days() > 0 && h.hours() === 0) {
          str += `${h.days()}天${h.hours()}小时`
        }
        if (h.hours() > 0) {
          str += `${h.hours()}小时`
        }
        if (h.minutes() > 0) {
          str += `${h.minutes()}分钟`
        }

        data.parkTime = str
      }

      if (data.parkStartTime) {
        data.parkStartTime = moment(data.parkStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }

      return data
    },
    /**
     * 处理缴费
     */
    async handlePay() {
      const { id: orderId } = this.parkingInfo
      if (this.isAli) {
        // 支付宝支付
        try {
          const res = await parkingPay({
            orderId,
            channelCode: YB_PAY_TYPES.YB_ALIPAY_USER_SCAN
          })
          window.location.href = res
        } catch (error) {
          this.$toast(error.message)
        }
      } else {
        // 易宝微信公众号支付
        try {
          const res = await parkingPay({
            orderId,
            channelCode: YB_PAY_TYPES.YB_WECHAT_OFFIACCOUNT,
            loginCode: getLoginCode()
          })
          if (res) {
            const payData = JSON.parse(res)
            this.onBridgeReady(payData)
          }
        } catch (error) {
          this.$toast(error.message)
        }
      }
    },
    onBridgeReady(payData) {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
        "appId": payData.appId,     //公众号ID，由商户传入     
        "timeStamp": payData.timeStamp,         //时间戳，自1970年以来的秒数     
        "nonceStr": payData.nonceStr, //随机串     
        "package": payData.package,
        "signType": payData.signType,         //微信签名方式：     
        "paySign": payData.paySign //微信签名 
      },
         (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            this.$toast('支付成功')
          }
          if (res.err_msg == "get_brand_wcpay_request:cancel") {
            this.$toast('用户取消支付')
          }
          if (res.err_msg == "get_brand_wcpay_request:fail") {
            this.$toast('支付失败')
          }
        });
    },
  }
}
</script>

<style lang="scss">
.parking-fee-container {
  height: 100vh;

  .nav-bar {
    height: 44px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .leading {
      position: absolute;
      left: 12px;
    }

    .title {
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }
  }

  .main {
    margin: 10px 12px;

    .header {
      background-color: #fff;
      border-radius: 4px;
      padding: 14px 16px 16px;
      box-sizing: border-box;

      .car-no {
        margin-top: 9px;
        background-color: #f6fafd;
        height: 50px;
        border-radius: 4px;
        color: #4d86e0;
        font-weight: bold;
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .content {
      margin-top: 10px;
      background-color: #fff;
      padding: 15px 16px 25px;
      border-radius: 4px;

      .title {
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        color: #333;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 15px;
      }

      .list {
        margin-top: 26px;

        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 19px;

          &:first-child {
            margin-top: 0;
          }

          .leading {
            font-size: 14px;
            font-weight: 500;
            color: #666;
          }

          .trailing {
            font-size: 14px;
            font-weight: 700;
            color: #333;

            &.primary {
              color: #4d86e0;
            }
          }
        }
      }
    }

    .footer {
      margin-top: 30px;

      .pay-btn {
        background-color: #4d86e0;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        border-radius: 4px;
      }

      .explain {
        margin-top: 30px;

        .title {
          font-size: 14px;
          font-weight: 700;
          color: #333;
          text-align: center;
        }

        .desc-list {
          margin-top: 20px;
          color: #666;
          font-weight: 500;
          font-size: 12px;
          line-height: 2;

          .strong {
            font-size: 13px;
            color: #333;
            margin-left: 5px;
          }
        }
      }
    }
  }

  .other-status {
    margin-top: 180px;
    text-align: center;

    .icon {
      width: 60px;
      height: 60px;
    }

    .status {
      margin-top: 22px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .hint {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 500;
      color: #666;
    }

    .no-data {
      width: 200px;
      height: 200px;
    }

    .no-vehicle {
      font-size: 16px;
      font-weight: 500;
      color: #999;
      margin-top: -10px;
    }
  }
}
</style>
